<template>
  <v-list dense>
    <v-list-item>
      <span class="text-body-1 grey--text px-2">
        {{ `${$t('PERSONS.ACCEPT_AGB')}: ` }}
      </span>
      <v-switch
        v-model="form.terms_accepted"
        class="px-2"
        :readonly="readonly"
        name="dsg_accepted"
      />
      <span class="px-4 text-body-1 grey--text">
        {{
          `${$t('ITEM.TIME')}: ${
            !form.terms_accepted_at
              ? $t('ITEM.EMPTY')
              : dateTimeFormat(form.terms_accepted_at)
          }`
        }}
      </span>

      <span class="px-2 text-body-1 grey--text">
        {{ `${$t('ORDERS.SOURCE')}: ` }}
      </span>
      <span class="text-subtitle-2">
        {{ form.terms_source || $t('ITEM.EMPTY') }}
      </span>

      <v-spacer />

      <language-select
        v-if="$can('sensitive-data')"
        item-text="name"
        item-value="id"
        class="pl-2"
        dense
        hide-details="auto"
        :label="$t('PERSONS.EXPORT_LETTER_FILE')"
        @change="downloadPdf"
      />
    </v-list-item>
    <v-list-item>
      <span class="px-2 text-body-1 grey--text">
        {{ `${$t('PERSONS.ACCEPT_DSG')}: ` }}
      </span>

      <v-switch
        v-model="form.dsg_accepted"
        class="px-2"
        :readonly="readonly"
        name="terms_accepted"
      />
      <span class="text-body-1 grey--text px-4">
        {{
          `${$t('ITEM.TIME')}: ${
            !form.dsg_accepted_at
              ? $t('ITEM.EMPTY')
              : dateTimeFormat(form.dsg_accepted_at)
          }`
        }}
      </span>

      <span class="text-body-1 grey--text px-2">
        {{ `${$t('ORDERS.SOURCE')}: ` }}
      </span>
      <span class="text-subtitle-2">
        {{ form.dsg_source || $t('ITEM.EMPTY') }}
      </span>
    </v-list-item>
  </v-list>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { dateTimeFormat } from '@/modules/_global/filters';
import LanguageSelect from '@/modules/_global/_components/LanguageSelect.vue';
import { PersonsService } from '@/services/persons.service';
import downloadFile from '@/modules/_global/mixins/download-file';

export default {
  name: 'DataProtectionForm',
  components: { LanguageSelect },

  filters: {
    dateTimeFormat
  },

  mixins: [formEditable, downloadFile],

  props: {
    description: {
      type: Object,
      default: () => ({})
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      form: {
        terms_accepted: false,
        dsg_accepted: false
      }
    };
  },

  mounted() {},

  methods: {
    dateTimeFormat,

    downloadPdf(languageId) {
      PersonsService.getPersonalInfoPdf(this.person.id, {
        language: languageId
      }).then(response => {
        this.downloadFile(response);
      });
    }
  }
};
</script>
